import "./App.css";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import CustomHomes from "./pages/CustomHomes";
import Design from "./pages/Design";
import BuildOnYourLot from "./pages/BuildOnYourLot";
import Process from "./pages/Process";
import Projects from "./pages/Projects";
import Locations from "./pages/Locations";
import CountyPage from "./pages/CountyPage";
import CityPage from "./pages/CityPage";
import About from "./pages/About";
import Resources from "./pages/Resources";
import ResourceArticle from "./pages/ResourceArticle";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import { Toaster } from "./components/ui/toaster";
import { COUNTIES } from "./data/site";

const countySlugs = COUNTIES.map((c) => c.slug);

// Dispatch /locations/:slug to a county or city page based on the slug.
function LocationRouter() {
  const { slug } = useParams();
  return countySlugs.includes(slug) ? <CountyPage key={slug} /> : <CityPage key={slug} />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/custom-homes" element={<CustomHomes />} />
            <Route path="/custom-home-design" element={<Design />} />
            <Route path="/build-on-your-lot" element={<BuildOnYourLot />} />
            <Route path="/our-process" element={<Process />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/locations/:slug" element={<LocationRouter />} />
            <Route path="/about" element={<About />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:slug" element={<ResourceArticle />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
